angular
    .module('dashboard')
    .component('callCenterOrders',
        {
            template: '<div><div ui-view="orderview"></div></div>'
        });